import React from 'react';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import {Button, Input} from 'ui-library';
import get from 'lodash/get';
import i18n from 'i18n';
import {connect} from 'react-redux';

import API from '../lib/api';
import Mixins from '../lib/mixins';
import {openChat} from 'utils/crispActions';

import {displayAlert} from '../actions/app';
import Helpers from '../lib/helpers';
import passwordRegex from '../mixins/passwordRegex';

import {UserLocaleSelector} from 'apps/shared/controllers';
import SettingsAccountContent from './settings-account-content';
import UserSettingsLocationPhone from './user-settings-location-phone';
import CellPhoneVerification from './../modules/cell-phone-verification';
import DeleteAdvertiserUser from 'modules/accounts/advertiser/containers/DeleteAdvertiserUser';

const MIN_LENGTH_FOR_PASSWORD = 6;

const SettingsAccount = createClass({
  propTypes: {
    user: PropTypes.object,
    account: PropTypes.object
  },

  mixins: [
    LinkedStateMixin,
    Mixins.linkMixin,
    passwordRegex
  ],

  validateTypes: {
    password: (val) => val.length >= MIN_LENGTH_FOR_PASSWORD,
    passwordToChange: (val, component) => val.length >= MIN_LENGTH_FOR_PASSWORD || !component.state.changingPassword,
    currentPassword: (val) => val.length >= MIN_LENGTH_FOR_PASSWORD
  },

  getInitialState() {
    return {
      emailInput: '',
      changingPassword: false,
      passwordToChange: '',
      currentPassword: '',
      showDelete: false,
      hoverCancel: false,
      password: '',
      errorMessage: null
    };
  },

  componentWillMount() {
    const email = get(this.props.user, ['email']);
    this.setState({emailInput: email});
  },

  saveUserInfo() {
    this.refs.settingsUserInfo.saveData();
  },

  saveUserLocationPhone() {
    this.refs.settingsLocationPhone.saveData();
  },

  onEmailChange(event) {
    this.setState({emailInput: event.target.value});
  },

  onDeleteSelect() {
    this.setState({showDelete: true});
  },

  onCancelDelete() {
    this.setState({
      showDelete: false,
      hoverCancel: false
    });
  },

  onHoverCancel() {
    this.setState({hoverCancel: true});
  },

  onBlurCancel() {
    this.setState({hoverCancel: false});
  },

  onShowChangePassword() {
    this.setState({
      changingPassword: true
    });
  },

  isValidPassword(passwordToChange) {
    return this.passwordRegex.test(passwordToChange);
  },

  onSavePassword() {
    const {emailInput, changingPassword, passwordToChange, currentPassword} = this.state;
    const data = {
      email: emailInput,
      currentPassword
    };

    this.setState({validationActive: false, errorMessage: ''});

    if (changingPassword && !this.isValidPassword(passwordToChange)) {
      this.setState({
        validationActive: true,
        errorMessage: i18n.get('RESET_PASSWORD_INVALID_LENGTH')
      });
      return;
    }

    if (!this.validateProperty('currentPassword', currentPassword) ||
        !this.validateProperty('passwordToChange', passwordToChange)) {
      this.setState({
        validationActive: true
      });
      return;
    }

    if (changingPassword && passwordToChange !== '') {
      data.password = passwordToChange;
    }

    API.updatePasswordUser(data, (err, res) => {
      if (res.code) return this.showError(res);

      displayAlert({
        type: 'success',
        message: i18n.get('ADV_SETTINGS_ACCOUNT_SAVE_SUCCESS_ALERT_MESSAGE')
      });
    });
  },

  onDeleteUser() {
    const {password} = this.state;
    this.setState({validationActive: false});

    if (!this.validateProperty('password', password)) {
      this.setState({validationActive: true});
      return;
    }

    API.deleteCurrentUser({password: this.state.password}, (err, res) => {
      if (res.code) return displayAlert({message: res.message});
      Helpers.destroyUserSession();
    });
  },

  showError({message}) {
    displayAlert({message, type: 'error'});
  },

  renderConfig() {
    const {user, partnerSettings} = this.props;
    const {emailInput, changingPassword, errorMessage} = this.state;
    const canEditUserData = true;
    const platformName = get(partnerSettings, 'partner.name', 'VoxFeed');

    return (
      <div>
        <div className='vf-row padding-top-2x'>
          <div className='col-xs-12'>
            <h2>{i18n.get('ADV_SETTINGS_ACCOUNT_PERSONAL_INFO_TITLE')}</h2>
          </div>
        </div>
        <div className='vf-row reverse-sm padding-top-1x'>
          <div className='col-xs-12 col-sm-4'>
            <div className='vf-descriptor'>
              {i18n.get('ADV_SETTINGS_ACCOUNT_PERSONAL_INFO_DESCRIPTION', {name: platformName})}
            </div>
          </div>
          <div className='col-xs-12 show-xs padding-top-2x' />
          <div className='col-xs-12 col-sm-8'>
            <SettingsAccountContent
              ref='settingsUserInfo'
              user={user}
              disabled={!canEditUserData}
            />
            <div className='vf-row padding-top-2x'>
              <div className='col-xs-12 col-md-offset-4 col-md-8'>
                <div className='margin-top-1x'>
                  <Button
                    color='primary'
                    onClick={this.saveUserInfo}
                    disabled={!canEditUserData}
                  >
                    {i18n.get('ADV_SETTINGS_ACCOUNT_SAVE')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='vf-row padding-top-2x'>
          <div className='col-xs-12'>
            <h2>{i18n.get('ADV_SETTINGS_ACCOUNT_LOCATION_AND_PHONE_TITLE')}</h2>
          </div>
        </div>
        <div className='vf-row reverse-sm padding-top-1x'>
          <div className='col-xs-12 col-sm-4'>
            <div className='vf-descriptor'>
              {i18n.get('ADV_SETTINGS_ACCOUNT_LOCATION_AND_PHONE_DESCRIPTION')}
            </div>
          </div>
          <div className='col-xs-12 show-xs padding-top-2x' />
          <div className='col-xs-12 col-sm-8'>
            <div className='vf-row'>
              <div className='col-xs-12 col-md-offset-4 col-md-8'>
                <UserSettingsLocationPhone
                  ref='settingsLocationPhone'
                  user={user}
                  cellPhoneVerificationComponent={CellPhoneVerification}
                />

                <div className='vf-simple-form-label'>
                  {i18n.get('INF_SETTINGS_ACCOUNT_LANGUAGE')}
                </div>

                <UserLocaleSelector />

                <div className='margin-top-2x'>
                  <Button color='primary' onClick={this.saveUserLocationPhone}>
                    {i18n.get('ADV_SETTINGS_ACCOUNT_SAVE')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='vf-row padding-top-3x'>
          <div className='col-xs-12'>
            <h2>{i18n.get('ADV_SETTINGS_ACCOUNT_EMAIL_AND_PASSWORD_TITLE')}</h2>
          </div>
        </div>
        <div className='vf-row reverse-sm padding-top-1x'>
          <div className='col-xs-12 col-sm-4'>
            <div className='vf-descriptor'>
              {i18n.get('ADV_SETTINGS_ACCOUNT_EMAIL_AND_PASSWORD_DESCRIPTION', {name: platformName})}
            </div>
          </div>
          <div className='col-xs-12 show-xs padding-top-2x' />
          <div className='col-xs-12 col-sm-8'>
            <div className='vf-row'>
              <div className='col-xs-12 col-md-offset-4 col-md-8'>
                <div className='padding-nonlateral'>
                  <label className='vf-simple-form-label'>
                    {i18n.get('ADV_SETTINGS_ACCOUNT_EMAIL_AND_PASSWORD_EMAIL_LABEL')}
                  </label>
                  <Input
                    value={emailInput}
                    onChange={this.onEmailChange}
                  />
                </div>

                <div className='padding-top-1x'>
                  <label className='vf-simple-form-label vf-block'>
                    {i18n.get('ADV_SETTINGS_ACCOUNT_EMAIL_AND_PASSWORD_PASSWORD_LABEL')}
                  </label>
                  {changingPassword ? (
                    <Input
                      type='password'
                      placeholder={
                        i18n.get('ADV_SETTINGS_ACCOUNT_EMAIL_AND_PASSWORD_NEW_PASSWORD_LABEL')
                      }
                      {...this.linkedValidation('passwordToChange')}
                    />
                  ) : (
                    <Button size='sm' onClick={this.onShowChangePassword}>
                      {i18n.get('ADV_SETTINGS_ACCOUNT_EMAIL_AND_PASSWORD_CHANGE_PASSWORD_LABEL')}
                    </Button>
                  )}

                  {errorMessage &&
                    <div className='margin-top-2x'>
                      <span className='vf-text-danger'>
                        {errorMessage}
                      </span>
                    </div>}

                </div>

                <div className='padding-top-1x'>
                  <label className='vf-simple-form-label'>
                    {i18n.get('ADV_SETTINGS_ACCOUNT_EMAIL_AND_PASSWORD_UPDATE_PASSWORD_LABEL')}
                  </label>
                  <Input
                    type='password'
                    placeholder={
                      i18n.get('ADV_SETTINGS_ACCOUNT_EMAIL_AND_PASSWORD_UPDATE_PASSWORD_LABEL')
                    }
                    {...this.linkedValidation('currentPassword')}
                  />
                </div>

                <div className='padding-top-2x'>
                  <Button color='primary' onClick={this.onSavePassword}>
                    {i18n.get('ADV_SETTINGS_ACCOUNT_SAVE')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='vf-row padding-top-3x'>
          <div className='col-xs-12 col-sm-8'>
            <div className='vf-row'>
              <div className='col-xs-12 col-md-offset-4 col-md-8'>
                <a onClick={this.onDeleteSelect}>
                  {i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_ACCOUNT_LABEL')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },

  renderDeleteAccount() {
    const {user, account, partnerSettings} = this.props;
    const {hoverCancel} = this.state;
    const faceIcon = hoverCancel ? <div className='vf-icon vf-face icon-smile-o' /> : <div className='vf-icon vf-face icon-frown-o' />;
    const platformName = get(partnerSettings, 'partner.name', 'VoxFeed');

    return (
      <div>
        <div className='vf-row padding-top-2x'>
          <div className='col-xs-12'>
            <h2>{i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_ACCOUNT_LABEL')}</h2>
          </div>
        </div>
        <div className='vf-row reverse-sm padding-top-2x'>
          <div className='col-xs-12 col-sm-offset-1 col-sm-2'>
            {faceIcon}
          </div>
          <div className='col-xs-12 show-xs padding-top-2x' />
          <div className='col-xs-12 col-sm-9 col-lg-offset-3 col-lg-6'>
            <div className='settings-account-delete'>
              <div className='vf-font-big'>
                <h4>{i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_ACCOUNT_PAGE_TITLE')}</h4>
                {i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_ACCOUNT_PAGE_TEXT_WE_CAN_CHANGE')}
                {' '}
                <a onClick={openChat}>
                  {i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_ACCOUNT_PAGE_TEXT_CONTACT_LINK')}
                </a>
              </div>

              <h4 className='padding-top-2x'>
                {i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_ACCOUNT_PAGE_IF_YOU_DELETE_TITLE', {name: platformName})}
              </h4>

              <ul>
                <li>
                  {i18n.get(
                    'ADV_SETTINGS_ACCOUNT_DELETE_ACCOUNT_PAGE_IF_YOU_DELETE_EARNINGS',
                    {earnings: i18n.getMoney({ amount: account.balance || 0 })}
                  )}
                </li>
                <li>
                  {i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_ACCOUNT_PAGE_IF_YOU_DELETE_PERFORMANCE')}
                </li>
                <li>
                  {i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_ACCOUNT_PAGE_IF_YOU_DELETE_AUDIENCE')}
                </li>
                <li>
                  {i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_ACCOUNT_PAGE_IF_YOU_DELETE_UNLINK')}
                </li>
                <li>
                  {i18n.get(
                    'ADV_SETTINGS_ACCOUNT_DELETE_ACCOUNT_PAGE_IF_YOU_DELETE_MISS_YOU',
                    {username: user.name}
                  )}
                </li>
              </ul>

              <br /><br />

              <b>{i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_ACCOUNT_PAGE_TYPE_YOUR_PASSWORD')}</b>

              <div className='padding-vertical-1x'>
                <Input
                  type='password'
                  placeholder={
                    i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_ACCOUNT_PAGE_PASSWORD_INPUT_LABEL')
                  }
                  {...this.linkedValidation('password')}
                />
              </div>
              <Button size='sm' color='primary' onClick={this.onDeleteUser}>{i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_ACCOUNT_PAGE_DELETE_ACCOUNT')}</Button>
              {' '}
              <Button size='sm' color='default' onClick={this.onCancelDelete} onMouseEnter={this.onHoverCancel} onMouseLeave={this.onBlurCancel}>{i18n.get('CANCEL')}</Button>
            </div>
          </div>
        </div>


      </div>
    );
  },

  render() {
    const {account} = this.props;
    const {showDelete} = this.state;
    const content = showDelete ? <DeleteAdvertiserUser account={account} onCancelDelete={this.onCancelDelete} /> : this.renderConfig();

    return (
      <div className='vf-wrapper'>
        <div className='vf-row'>
          <div className='col-xs-12'>
            <h3 className='flex-1'>
              {i18n.get('ADV_SETTINGS_ACCOUNT_TITLE')}
            </h3>
          </div>
        </div>
        {content}
      </div>
    );
  }

});

const mapStateToProps = state => ({
  partnerSettings: state.app.partnerSettings
});
module.exports = connect(mapStateToProps)(SettingsAccount);
